export default (function (_ref) {
  var request = _ref.request;
  return {
    labSpeciesAdd: function labSpeciesAdd(data) {
      return request({
        url: '/mng/labSpecies/add',
        method: 'post',
        data: data
      });
    },
    labSpeciesModify: function labSpeciesModify(data) {
      return request({
        url: "/mng/labSpecies/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    labSpeciesDel: function labSpeciesDel(id) {
      return request({
        url: "/mng/labSpecies/".concat(id, "/del"),
        method: 'delete'
      });
    },
    labSpeciesQuery: function labSpeciesQuery(data) {
      return request({
        url: '/mng/labSpecies/query',
        method: 'get',
        params: data
      });
    },
    labSpeciesDetail: function labSpeciesDetail(id) {
      return request({
        url: "/mng/labSpecies/".concat(id, "/detail"),
        method: 'get'
      });
    }
  };
});